import React from 'react';
import styled from 'styled-components';
import { Icon } from 'lmc-ui-library';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const BackWrapper = styled.div`
  margin-right: 24px;
`;
const FirmDetailsWrapper = styled.div``;

const FirmName = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  color: #2d3540;
`;

const Subheading = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #6c7279;
  margin-top: 4px;

  span {
    margin-right: 7px;
  }
`;

interface Props {
  clubName: string;
  clubId: string;
  clubUpdatedAt: string;
}

const Header: React.FC<Props> = ({ clubName, clubId, clubUpdatedAt }) => {
  return (
    <Wrapper>
      <BackWrapper>
        <Link to={'/bp/clubs'}>
          <Icon type="iconLeft" color="#6C7279" />
        </Link>
      </BackWrapper>
      <FirmDetailsWrapper>
        <FirmName>{clubName}</FirmName>
        <Subheading>
          <span>Updated: {clubUpdatedAt}</span>
        </Subheading>
      </FirmDetailsWrapper>
    </Wrapper>
  );
};

export default Header;
